import React, { useCallback } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
// import ReactGA from 'react-ga';
import { useTranslation } from 'react-i18next';
import { gaEventPush } from '../functions/ga';

const useStyles = (primary) => makeStyles((theme) => ({
    link: {
        marginLeft: 10,
        marginRight: 10,
        width: 20,
        height: 20,
        textDecoration: 'none'
    },
    icon: {
        '& path': {
            fill: primary ? theme.palette.primary.main : theme.palette.white.main,
        },
        width: 20,
        height: 20,
    }
}))

const SocialLinkComponent = ({ Icon, href, alt, primary }) => {
    const classes = useStyles(primary)();
    const { t } = useTranslation();
    const handleGa = useCallback(() => {
        gaEventPush('Social', `${t('ga.social_networks')} ${alt}`)
    }, [t, alt])
    return (
        <a href={href} title={alt} rel="nofollow" className={classes.link} onClick={handleGa}>
            <Icon className={classes.icon} />
        </a>
    )
}


export default React.memo(SocialLinkComponent);